import React from 'react'

import { Icon } from '@/components/Icon/Icon'
import { pxToRem } from '@/shared/styles/themes'
import { faBaby } from '@fortawesome/pro-light-svg-icons/faBaby'
import { faBookHeart } from '@fortawesome/pro-light-svg-icons/faBookHeart'
import { faChild } from '@fortawesome/pro-light-svg-icons/faChild'
import { faEnvelopeOpen } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpen'
import { faGift } from '@fortawesome/pro-light-svg-icons/faGift'
import { faHeart } from '@fortawesome/pro-light-svg-icons/faHeart'
import { faPaintbrush } from '@fortawesome/pro-light-svg-icons/faPaintbrush'
import { faPalette } from '@fortawesome/pro-light-svg-icons/faPalette'
import type { IconLookup } from '@fortawesome/fontawesome-common-types'
import { Box, Grid, styled, Typography } from '@mui/material'

import type { Highlight } from './types'

const ICON_MAP: Record<string, IconLookup> = {
  heart: faHeart,
  palette: faPalette,
  child: faChild,
  'book-heart': faBookHeart,
  'envelope-heart': faEnvelopeOpen,
  baby: faBaby,
  gift: faGift,
  paintbrush: faPaintbrush,
}

interface HighlightsSectionProps {
  highlights: Highlight[]
}

export const HighlightsSection: React.FC<HighlightsSectionProps> = ({ highlights }) => (
  <StyledSection>
    <Grid container spacing={3}>
      {highlights.map((item) => (
        <Grid item xs={6} md={3} key={item.title}>
          <StyledCard>
            <StyledIconWrapper>
              <Icon
                icon={ICON_MAP[item.icon] || faHeart}
                sx={{ fontSize: pxToRem(28), color: 'primary.main' }}
              />
            </StyledIconWrapper>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
              {item.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.description}
            </Typography>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  </StyledSection>
)

const StyledSection = styled(Box)`
  padding: ${pxToRem(48)} 0 ${pxToRem(32)};
`

const StyledCard = styled(Box)`
  text-align: center;
  padding: ${pxToRem(16)};
`

const StyledIconWrapper = styled(Box)`
  margin-bottom: ${pxToRem(12)};
`
